import { message } from 'antd';
import { isCancel } from 'axios';

const isNetworkError = (error) =>
  error instanceof Error && error.name === 'NetworkError';
const isCancelled = (error) => isCancel(error);

const showErrorMessage = (error, text = 'Произошла ошибка') => {
  if (!error) {
    return;
  }
  if (error.response?.status === 401) {
    return;
  }
  if (error.response?.status === 400 && error.response?.data) {
    return message.error(error.response?.data?.title || error.response?.data);
  }
  if (isNetworkError(error)) {
    message.error('Ошибка сети. Проверьте интернет-соединение');
    return;
  }
  if (isCancelled(error)) {
    return;
  }
  message.error(text);
};

export default showErrorMessage;
